import React from 'react';

export const HomePage = () => (
    <div className="space-y-6">
        <h2 className="heading-primary-1 text-4xl font-extrabold text-center mb-6">Welcome to Chico Darts!</h2>
        <p className="text-lg leading-relaxed text">
            The <strong className="font-bold">Chico Area Dart Association</strong> welcomes players of all skill levels in Chico and the surrounding areas of the North Sacramento Valley!<br />
        </p>
        <p className="text-lg leading-relaxed text">
            <strong className="font-bold">League Play</strong> typically takes place for a Spring and Fall season! Contact us to join our mailing list and keep up to date on the latest info from CADA!
        </p>
        <p className="text-lg leading-relaxed text">
            Explore the navigation menu to discover different sections, including information about our league, point series, and more.
        </p>
        <p className="text-lg leading-relaxed text">
            If you are a member or an admin, try logging in to access exclusive content like your dashboard, profile, or site settings.
        </p>
        <div className="mt-10 flex justify-center">
            {/* Updated image source to a placeholder URL */}
            <img src="https://placehold.co/600x300/60a5fa/ffffff?text=ChicoDarts+Homepage" alt="Homepage Banner" className="rounded-lg shadow-md max-w-full h-auto" />
        </div>
    </div>
)